import ManageQuestionAnswersPage from './manageQuestionAnswersPage'

export { ManageQuestionAnswersPage }
